module.exports = __webpack_public_path__ + "static/media/main28.54ad8608.png";